export default {
    cekLokal() {
        var url = "";
        return url;
    },
    buka() {
        var url = "buka";
        return url;
    },
    kirim() {
        var url = "kirim";
        return url;
    },
    scan() {
        var url = "scan";
        return url;
    },
    cek() {
        var url = "cek";
        return url;
    },
    isonline() {
        var url = "isonline";
        return url;
    }
}


// WEBPACK FOOTER //
// ./src/globalFunc/InterfaceBotLokalan.js